import React from 'react'
import { Form, Button, Divider, Empty, message } from 'antd'
import { FormComponent } from '../../../../BaseComponent'
import { ApplicationTagContextData } from '../../../../../context/ApplicationTagContext'
import GenericList from '../../../../GenericList'
import { ProcessTagConstants } from '../../../../../helpers/enums/ProcessTag'
import IApplicationTagEventShelter from '../../../../../interfaces/IApplicationTagEventShelter'
import IApplicationTagShelter from '../../../../../interfaces/IApplicationTagShelter'

export type ProcessTagEventsProps = {
  shelterUuid: string,

  applicationTagContext: ApplicationTagContextData
}

export default class ProcessTagEvents extends FormComponent<ProcessTagEventsProps> {

  componentDidUpdate() {
    this.validateAccessPermissions()
    this.parseContextErrors(this.props.applicationTagContext.error)
  }

  private parseValues = (shelterEvents: IApplicationTagEventShelter[]) => {
    return shelterEvents.map(v => {
      return {
        uuid: v.uuid,
        tag_uuid: v.applicationTag?.uuid,
        status_key: v.status_key,
        action_key: v.action_key
      }
    })
  }

  private handleSave = async (values: any) => {
    const { shelterUuid, applicationTagContext } = this.props

    try {
      await applicationTagContext.requestShelterEventSave({
        organization_shelter_uuid: shelterUuid,
        organization_shelter_events: values.process_tag_event || []
      })

      message.success('Process tag events saved successfully!')
    } catch (error) {
      message.error(`Failed to save process tag events. Reason: ${error}`)
    }
  }

  private renderCustomSettings = (shelterTags: IApplicationTagShelter[]) => {
    if (!this.formRef) return null

    ProcessTagConstants.EVENT_CUSTOM_FIELDS.fields?.forEach(v => {
      if (v.name === 'tag_uuid') {
        v.options = shelterTags.map(tag => {
          return {
            label: tag.applicationTag.name,
            value: tag.applicationTag.uuid
          }
        }) as any
      }
    })

    return (
      <GenericList
        key={`process_tag_event`}
        listName="process_tag_event"
        fieldsLabel="initial"
        form={this.formRef}
        label={ProcessTagConstants.EVENT_CUSTOM_FIELDS.label}
        description='This feature allows you to automate the insertion/update of process tags in Adoption Inquiries/Applications based on events like Status Changes, and others.'
        fields={ProcessTagConstants.EVENT_CUSTOM_FIELDS.fields || []}
      />
    )
  }


  render() {
    const { applicationTagContext } = this.props
    const shelterTags = applicationTagContext.shelterTags || []
    const shelterEvents = applicationTagContext.shelterEvents || []

    if (shelterTags.length === 0) {
      return <Empty />
    }

    return (
      <Form
        name="process_tag_events"
        initialValues={{
          process_tag_event: this.parseValues(shelterEvents)
        }}
        layout="vertical"
        ref={(ref) => {
          if (!this.formRef) {
            this.formRef = ref
            this.forceUpdate()
          }
        }}
        onFinish={this.handleSave}
      >
        {
          this.renderCustomSettings(shelterTags)
        }

        <Divider />

        <Button
          type="primary"
          htmlType="submit"
          size="large"
          loading={!!applicationTagContext.fetching}
          ref={(refs) => this.actionRefs.save = refs}
          block
        >
          Save Events
        </Button>
      </Form>
    )
  }
}